<template>
  <div class="custom">
    <template v-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.SERVICE">
      <div>
        <h1>
          <label>{{ extension.title }}</label>
          <a
            v-if="extension.hyperlinks_text"
            :href="extension.hyperlinks_text.value"
            target="view_window"
            >{{ extension.hyperlinks_text.key }}</a
          >
        </h1>
        <ul v-if="extension.item && extension.item.length > 0">
          <li v-for="(item, index) in extension.item" :key="index">
            <a
              v-if="isUrl(item.value)"
              :href="item.value"
              target="view_window"
              >{{ item.key }}</a
            >
            <p v-else>
              {{ item.key }}
            </p>
          </li>
        </ul>
        <article>{{ extension.description }}</article>
      </div>
    </template>
    <template
      v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.EVALUATE"
    >
      <div class="evaluate">
        <h1>{{ TUITranslateService.t("message.custom.对本次服务评价") }}</h1>
        <ul class="evaluate-list">
          <li
            v-for="(item, index) in Math.max(customData.score, 0)"
            :key="index"
            class="evaluate-list-item"
          >
            <Icon :file="star" class="file-icon" />
          </li>
        </ul>
        <article>{{ customData.comment }}</article>
      </div>
    </template>
    <template v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.ORDER">
      <div class="order" @click="openLink(customData.link)">
        <img :src="customData.imageUrl" />
        <main>
          <h1>{{ customData.title }}</h1>
          <p>{{ customData.description }}</p>
          <span>{{ customData.price }}</span>
        </main>
      </div>
    </template>
    <template v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.LINK">
      <div
        v-if="customData.type == 1"
        class="textLink"
        @click="hanldialogVisible(customData.employee_approval_id)"
      >
        <p class="approval_name">{{ customData.text }}</p>
        <p class="tips">
          {{ customData.tips
          }}<span class="text">{{ customData.employee_approval_name }}</span>
        </p>
        <!-- <a :href="customData.link" target="view_window">{{
          TUITranslateService.t("message.custom.查看详情>>")
        }}</a> -->
      </div>
      <div
        v-if="customData.type == 2"
        class="textLink"
        @click="hanlVisible(customData.employee_log_id)"
      >
        <p class="approval_name">{{ customData.text }}</p>
        <p class="tips">
          {{ customData.tips
          }}<span class="text">{{ customData.employee_log_name }}</span>
        </p>
        <!-- <a :href="customData.link" target="view_window">{{
          TUITranslateService.t("message.custom.查看详情>>")
        }}</a> -->
      </div>
    </template>
    <template v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.DETAIL">
      <div
        class="textDETAIL"
        @click="hanldialogVisible(customData.employee_approval_id)"
      >
        <p class="approval_name">{{ customData.title }}</p>
        <div
          class="flex-row"
          v-for="(item, index) in customData.form_content"
          :key="index"
        >
          <span class="ddkey">{{ item.key }}:</span>
          <div class="ddvalue">{{ item.value }}</div>
        </div>
        <div class="look">查看详情</div>
      </div>
    </template>
    <template v-else>
      <span v-html="content.custom" />
    </template>
    <Dialog
      :show="dialogVisible"
      :isH5="!isPC"
      :isFooterShow="false"
      @update:show="toggleShow"
    >
      <div class="textdialog">
        <div class="dialog-main-header">
          <p class="dialog-main-title">
            {{ TUITranslateService.t(`审核流程`) }}
          </p>
          <div class="flex">
            <prints :dataInfo="dataInfo"></prints>
            <share :dataInfo="dataInfo"></share>
          </div>
        </div>
        <div
          v-if="!!dataInfo.approval_no"
          class="flowlist"
          style="user-select: text !important"
        >
          <div class="flex ai no">
            <div class="">
              <span class="label">审批编号：</span>
              <span>{{ dataInfo.approval_no }}</span>
            </div>
            <div class="time flex ai">
              <img
                class="ta"
                v-if="dataInfo.creator.picture"
                :src="dataInfo.creator.picture"
                fit="cover"
              />
              <div class="tan" v-else>
                {{
                  dataInfo.creator.name ? dataInfo.creator.name.slice(-1) : ""
                }}
              </div>
              <span class="tat"
                >{{ dataInfo.creator.name }}
                {{ dataInfo.create_time }} 发起</span
              >
            </div>
          </div>
          <div class="dataInfo">
            <div class="content">
              <div class="flex mb20">
                <div>
                  <span class="title">{{ dataInfo.approval_name }}</span>
                  <span :class="`status${dataInfo.status} status`">{{
                    toStr(
                      {
                        1: "审批中",
                        2: "已撤销",
                        3: "审批通过",
                        4: "审批拒绝",
                      },
                      dataInfo.status
                    )
                  }}</span>
                </div>
              </div>
              <formcontent :form_config="form_config"
                ><div>
                  <h3 class="mt20">审批流程</h3>
                  <flowList
                    :flow_list="flow_list"
                    :dataInfo="dataInfo"
                    :stepsActive="stepsActive"
                  ></flowList></div
              ></formcontent>
              <h3 class="mt20">审批流程<span class="aut" v-if="dataInfo.auto_pass == 1">(已启用自动去重)</span></h3>
              <flowList
                :flow_list="flow_list"
                :dataInfo="dataInfo"
                :stepsActive="stepsActive"
              ></flowList>
            </div>
          </div>
        </div>
        <div class="index_footerWrap" style="text-align: right">
          <!-- 1:'审批中',2:'已撤销',3:'审批通过',4:'审批拒绝' -->
          <el-button plain @click="handturnOver" v-if="isflow">转交</el-button>
          <el-button plain @click="handsendBack" v-if="isflow">退回</el-button>
          <el-button plain @click="handleComment">评论</el-button>
          <el-button
            plain
            @click="handledeal(2, '拒绝')"
            type="primary"
            v-if="isflow && person_type != 6"
            >拒绝</el-button
          >
          <el-button
            type="primary"
            @click="handledeal(1, '同意')"
            v-if="isflow && person_type != 6"
            >同意</el-button
          >
          <el-button
            type="primary"
            @click="handledeal(1, '提交')"
            v-if="isflow && person_type == 6"
            >提交</el-button
          >
        </div>
      </div>
    </Dialog>
    <Dialog
      title=""
      :show="visible"
      :isH5="!isPC"
      :isFooterShow="false"
      @update:show="toggleShow1"
    >
      <div class="log" ref="log">
        <div class="right_t">
          <div class="flex ju">
            <div class="right_ts">{{ customData.employee_log_name }}</div>
          </div>
          <div class="flex ju">
            <div class="label">{{ commentdata?.create_time }} 提交</div>
          </div>
        </div>
        <logform :logcontent="logcontent"></logform>
        <logcomment
          :commentdata="commentdata"
          @logcomment="setlogcomment"
        ></logcomment>
      </div>
    </Dialog>
    <Comment
      ref="comment"
      @refresh="hanldialogVisible(customData.employee_approval_id)"
    ></Comment>
    <SendBack
      ref="sendBack"
      @refresh="hanldialogVisible(customData.employee_approval_id)"
    ></SendBack>
    <TurnOver
      ref="turnOver"
      @refresh="hanldialogVisible(customData.employee_approval_id)"
    ></TurnOver>
    <Deal
      ref="deal"
      @refresh="hanldialogVisible(customData.employee_approval_id)"
      :status="status"
      :title="title"
    ></Deal>
  </div>
</template>

<script lang="ts" setup>
import { getdetail, getcomment } from "@/api";
import { watchEffect, ref } from "../../../../adapter-vue";
import {
  TUITranslateService,
  IMessageModel,
} from "@tencentcloud/chat-uikit-engine";
import { isUrl, JSONToObject } from "../../../../utils/index";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { ICustomMessagePayload } from "../../../../interface";
import Icon from "../../../common/Icon.vue";
import star from "../../../../assets/icon/star-light.png";
import Dialog from "../../../common/Dialog/index.vue";
import { isPC } from "../../../../utils/env";
import flowList from "@/components/flowList.vue";
import formcontent from "@/components/formcontent.vue";
import logcomment from "@/components/logcomment.vue";
import logform from "@/components/logform.vue";
import Comment from "@/components/Comment.vue";
import Deal from "@/components/deal.vue";
import SendBack from "@/components/sendBack.vue";
import TurnOver from "@/components/turnOver.vue";
import prints from "@/components/print.vue";
import share from "@/components/share.vue";
import { durationLabelComponent } from '@/views/approve/sponsor/components/const.js'
const comment = ref<InstanceType<typeof Comment> | null>(null);
const deal = ref<InstanceType<typeof Deal> | null>(null);
const sendBack = ref<InstanceType<typeof SendBack> | null>(null);
const turnOver = ref<InstanceType<typeof TurnOver> | null>(null);

interface Props {
  messageItem: IMessageModel;
  content: any;
}

const props = withDefaults(defineProps<Props>(), {
  messageItem: undefined,
  content: undefined,
});

const custom = ref();
const isflow = ref(false);
const flow_list = ref<any[]>([]);
const dataInfo = ref<any>({});
const form_config = ref<any>([]);
const stepsActive = ref(1);
const dialogVisible = ref(false);
const visible = ref(false);
const message = ref<IMessageModel>();
const extension = ref();
const logcontent = ref([]);
const commentdata = ref({});
const customData = ref<ICustomMessagePayload>({
  businessID: "",
});
const status = ref(1);
const title = ref("");
const person_type = ref(0);

const log = ref<HTMLElement>();
watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  customData.value = payload.data || "";
  customData.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const hanldialogVisible = (id) => {
  getdetail({ id }).then((res) => {
    let flow = res.data.flow_list || [];
    flow_list.value = flow.map((item) => {
      let processor = item.processor
        ? item.processor
            .split(",")
            .filter((i) => i)
            .map((i) => i * 1)
        : "";
      let employees = Array.isArray(item.employees) ? item.employees : [];
      return {
        ...item,
        employees:
          processor && item.person_type == 4
            ? employees.filter((v) => processor.indexOf(v.id) > -1)
            : employees,
      };
    });
    person_type.value =
      flow_list.value[res.data.cur_flow_level - 1]?.person_type || 0;
    form_config.value = res.data.form_content.fields;
    //加入时长的显示
    let durationFieldRightIndex = form_config.value.findIndex(
              (i:any) => i.__config__.show_duration);
    if (durationFieldRightIndex > -1) {
              let durationObj = form_config.value[durationFieldRightIndex];
              let durationLabelComponent_ = durationLabelComponent;
              let danweiMap = {
                1: "小时",
                2: "天",
                3: "天",
              };
              let str = durationObj.__config__.duration;
              let danwei = danweiMap[durationObj.__config__.duration_type];
              let field = {
                ...durationLabelComponent_,
                __config__: {
                  ...durationLabelComponent_.__config__,
                  defaultValue: JSON.stringify(
                    `${str}${danwei}` ? `${str}${danwei}` : ""
                  ),
                },
              };
              form_config.value.splice(
                durationFieldRightIndex + 1,
                0,
                field
              );
            }
    //
    console.log(form_config.value,'form_config.value')
    stepsActive.value = res.data.cur_flow_level;
    dataInfo.value = res.data;
    let userid = localStorage.getItem("userid");
    let cur_flow = dataInfo.value.cur_flow;
    let employees = cur_flow.employees ? cur_flow.employees : [];
    isflow.value = employees.some((item) => {
      return item.id == userid && item.is_processed !== 1;
    });
    dialogVisible.value = true;
  });
};
const hanlVisible = (id) => {
  getcomment({ id })
    .then((res) => {
      commentdata.value = res.data;
      let form_content = res.data.form_content || res.data.form_config;
      let c = form_content ? JSON.parse(form_content) : [];
      let arr = c ? c.fields || c : [];
      logcontent.value = arr != null && arr.length > 0 ? arr : [];
      console.log(log.value);
      visible.value = true;
    })
    .then(() => {
      log.value?.scrollTo({ top: 9999999999 });
    });
};
const setlogcomment = (data) => {
  hanlVisible(commentdata.value?.id);
};
const toggleShow = (showStatus: boolean) => {
  dialogVisible.value = showStatus;
};

const toggleShow1 = (showStatus: boolean) => {
  visible.value = showStatus;
};
const openLink = (url: any) => {
  window.open(url);
};
const toStr = (data, key) => {
  return data[key];
};
const handturnOver = () => {
  let id = dataInfo.value.flow_list.filter((item) => item.flow_status == 1)[0]
    .id;
  let dom = turnOver.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value, id);
  dom = null;
};
const handsendBack = () => {
  let id = dataInfo.value.flow_list.filter((item) => item.flow_status == 1)[0]
    .id;
  let dom = sendBack.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value, id);
  dom = null;
};
const handledeal = (status1, title1) => {
  let id = dataInfo.value.flow_list.filter((item) => item.flow_status == 1)[0]
    .id;
  status.value = status1;
  title.value = title1;
  let dom = deal.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value, id);
  dom = null;
};
const handleComment = () => {
  let dom = comment.value;
  dom?.toggle(true);
  dom?.getDetail(dataInfo.value);
  dom = null;
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/styles/common";

a {
  color: #679ce1;
}
.ai {
  align-items: center;
}
.custom {
  font-size: 14px;
  h1 {
    font-size: 14px;
    color: #000;
  }

  h1,
  a,
  p {
    font-size: 14px;
  }

  .evaluate {
    ul {
      display: flex;
      padding: 10px 0;
    }

    &-list {
      display: flex;
      flex-direction: row;

      &-item {
        padding: 0 2px;
      }
    }
  }

  .order {
    display: flex;

    main {
      padding-left: 5px;

      p {
        font-family: PingFangSC-Regular;
        width: 145px;
        line-height: 17px;
        font-size: 14px;
        color: #999;
        letter-spacing: 0;
        margin-bottom: 6px;
        word-break: break-word;
      }

      span {
        font-family: PingFangSC-Regular;
        line-height: 25px;
        color: #ff7201;
      }
    }

    img {
      width: 67px;
      height: 67px;
    }
  }
}
.approval_name {
  font-size: 16px;
  font-weight: 600;
}
.tips {
  color: #999;
  font-weight: 600;
}
.text {
  color: #0476fc;
  font-weight: 600;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.flex-row{
	display: flex;
}
.no {
  height: 50px;
  line-height: 50px;
  border-bottom: solid 1px #eee;
  font-weight: bold;
  font-size: 14px;
}
.label {
  color: #999;
}
.dataInfo {
  flex: 1;
  overflow-y: scroll;
}
.flowlist {
  padding: 20px 0 0;
  height: 700px;
  overflow: auto;
}
.content {
  padding: 30px 0;

  .title {
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .time {
    display: flex;
    align-items: center;
    color: #999;
  }
}
.mb20 {
  margin-bottom: 20px;
}
.content {
  padding: 30px 0;

  .title {
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .time {
    display: flex;
    align-items: center;
    color: #999;
  }
}
.ta {
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
}
.tan {
  background: #0476fc;
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.tat {
  font-weight: 500;
  font-size: 12px;
}
.mt20 {
  margin-top: 20px;
}
.log {
  width: 500px;
  height: 80vh;
  overflow-y: scroll;
}
.right_t {
  height: 80px;
  background: #ffffff;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 2;
}
.right_ts {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}
.ddkey {
  line-height: 2;
}
.ddvalue {
  line-height: 2;
  flex:1;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.look {
  height: 40px;
  background: #0476fc;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  margin: 10px 0 0;
  cursor: pointer;
}
.index_footerWrap {
  padding: 10px 20px 10px;
  background: #fff;
}
.textDETAIL {
  width: 300px;
}
.textdialog {
  width: 900px;
}
.aut{
	font-size: 12px;
	color: #999;
	font-weight: 500;
}
</style>
